import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {trackEvent} from '../../../utils/tracking.js';
import { withGigCardContext } from '../../gig_card_context';
import '@fiverr/i18n/singleton';
import './style.scss';

class CollectionPopup extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            collectionValue: '',
            withError: false,
            errorMsg: i18n.t('general.went_wrong')
        };

        this.collectionChange = this.collectionChange.bind(this);
        this.collectionSubmit = this.collectionSubmit.bind(this);
    }

    collectionChange(e) {
        this.setState({
            collectionValue: e.target.value
        });
    }

    collectionSubmit(e) {
        e.preventDefault();

        const newCollection = this.state.collectionValue,
            {gigId, popupCallback, sellerId, user} = this.props,
            collectionLimits = {
                min: 5,
                max: 60
            };

        if (newCollection.length >= collectionLimits.min && newCollection.length <= collectionLimits.max) {
            this.setState({
                withError: false
            });

            this.props.saveCollection(gigId, newCollection)
                .then(() => {
                    popupCallback(e);

                    const payload = {
                        collection: {
                            type: 'gig',
                            source: 'gig_card',
                            name: newCollection
                        },
                        user: {
                            id: user.userId
                        },
                        seller: {
                            id: sellerId
                        },
                        gig: {
                            id: gigId
                        }
                    };

                    trackEvent('collections_list-created', this.props.cardType, this.props.cardSize);
                    trackEvent('collections.create', this.props.cardType, this.props.cardSize, 'click', payload, 'bigquery');
                })
                .catch((ajaxResp) => {
                    this.setState({
                        withError: true,
                        errorMsg: ajaxResp || i18n.t('collections.errors.went_wrong')
                    });
                });
        } else {
            this.setState({
                withError: true,
                errorMsg: i18n.t('collections.errors.length_error')
            });
        }
    }

    render() {
        const {popupCallback} = this.props,
            {collectionValue, withError, errorMsg} = this.state;

        return (
            <div className="gig-fav-popup">
                <div className="behind" onClick={(e) => popupCallback(e)}></div>
                <aside className="modal popup-base">
                    <header>
                        <a href="#"
                            className="btn-close"
                            rel="noindex, nofollow"
                            onClick={(e) => popupCallback(e)}>
                            &times;
                        </a>
                        <h2 className="cap">{i18n.t('collections.errors.name_new_coll')}</h2>
                    </header>
                    <form className="new-coll-form general-form-field-wrap" onSubmit={this.collectionSubmit}>
                        <div className="popup-content">
                            <input type="text"
                                name="collection"
                                id="collection"
                                placeholder={i18n.t('collections.collection_name')}
                                onChange={this.collectionChange}
                                value={collectionValue}
                                className={withError ? 'with-error' : ''}/>
                            {withError && <div className="error-container">
                                <p className="msg-error">{errorMsg}</p>
                            </div>}
                        </div>
                        <footer>
                            <input type="submit"
                                className="btn-standard btn-green-grad"
                                value={i18n.t('general.ok')}/>
                        </footer>
                    </form>
                </aside>
            </div>
        );
    }
}

CollectionPopup.propTypes = {
    gigId: PropTypes.string,
    popupCallback: PropTypes.func,
    saveCollection: PropTypes.func
};

const contextSelector = ({ user }) => ({ user });

export {CollectionPopup as UnwrappedCollectionPopup};

export default withGigCardContext(contextSelector)(CollectionPopup);



// WEBPACK FOOTER //
// ./src/shared/collect_gig/collection_popup/index.js